import React, { useEffect } from 'react';
import { useColorMode, useColorModeValue } from '@chakra-ui/react';
import Header from 'components/Header';
import ProfissionaisModule from 'modules/ProfissionaisModule';
import { DefaultPageContainer, ContentContainer, LeftContainer } from '../../styles/DefaultPage.styles';

const Agendas: React.FC = () => {
  const { toggleColorMode } = useColorMode();
  const currentTheme = useColorModeValue('light', 'dark');

  return (
    <>
      <Header
        theme={currentTheme}
        toggleTheme={toggleColorMode}
      />
      <DefaultPageContainer>
        <ContentContainer>
          <LeftContainer>
            <ProfissionaisModule />
          </LeftContainer>
        </ContentContainer>
      </DefaultPageContainer>
    </>
  );
};

export default Agendas;
